import React from 'react';

const MainSection = ({ personal, currentTheme }) => {
  // 배경 이미지가 테마와 무관하게 동일하므로 폰트 색상도 통일
  const colors = {
    mainTitle: 'text-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]',  // 흰색 + 그림자
    nameHighlight: 'text-orange-400 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]', // 주황색 강조
    englishName: 'text-gray-100 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]',
    description: 'text-gray-100 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]', // 다른 텍스트와 동일한 음영
    subtitle: 'text-gray-100 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]', // 다른 텍스트와 동일한 음영
    pointColor: 'text-orange-400 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]' // 다른 텍스트와 동일한 음영
  };

  return (
    <div className="space-y-8 drop-shadow-[0_4px_12px_rgba(0,0,0,0.9)]">
      {/* Main Content */}
      <div className="space-y-6">
        {/* Name & Title */}
        <div className="space-y-4">
          <h1 className={`text-3xl lg:text-4xl xl:text-5xl font-bold leading-tight word-break-keep ${colors.mainTitle}`}>
            안녕하세요,
            <br />
            <span className={colors.nameHighlight}>{personal.name}</span>입니다.
          </h1>

          <div className="inline-block px-4 py-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-full font-medium drop-shadow-[0_4px_12px_rgba(0,0,0,0.9)]">
            {personal.title}
          </div>
        </div>

        {/* Subtitle */}
        <p className={`text-lg lg:text-xl font-medium word-break-keep ${colors.subtitle}`}>
          <span className={colors.pointColor}>일상</span>에 <span className={colors.pointColor}>편리</span>한 도구를 개발합니다.
        </p>

        {/* Description */}
        <p className={`text-lg leading-relaxed max-w-2xl word-break-keep ${colors.description}`}>
          안녕하세요! 사용자의 <span className={colors.pointColor}>일상</span>을 더 <span className={colors.pointColor}>편리</span>하게 만드는 도구들을 개발하는 <span className={colors.nameHighlight}>{personal.name}</span>입니다. 새로운 기술을 배우고 실제 문제를 해결하는 것을 좋아합니다.
        </p>
      </div>
    </div>
  );
};

export default MainSection;